import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";

// GLOBAL STATE MANAGEMENT SITS IN APP.JS
import {
  PaymentContext,
  ShootSelectionContext,
  PaymentErrorContext,
  CustomerDetailsContext,
  BookingConfirmationContext,
} from "./AppContext";

//  RENDERED COMPONENTS TO DOM
import Header from "./components/Header";
import WelcomeSection from "./components/WelcomeSection";
import ShootSelector from "./components/ShootSelector";
import EnterDetails from "./components/EnterDetails";
import PaypalButtons from "./components/PaypalButtons";
import PaymentError from "./components/PaymentError";
import BookingComplete from "./components/BookingComplete";

// STYLESHEETS
import "./App.css";

function App() {
  // APPLICATION STATE
  const [paymentError, setPaymentError] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState({ name: "" });
  const [basketOpen, setBasketOpen] = useState(false);
  const [timeslotChosen, setTimeslotChosen] = useState(false);
  const [timeslotsLoaded, setTimeslotsLoaded] = useState(false);
  const [timeslots, setTimeslots] = useState();
  const [customerName, setCustomerName] = useState("");
  const [customerEmail, setCustomerEmail] = useState();
  const [numberOfChildren, setNumberOfChildren] = useState("1");
  const [detailsEntered, setDetailsEntered] = useState(false);
  const [windowSize, setWindowSize] = useState();
  const [bookingMade, setBookingMade] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowSize(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const getTimeslots = async () => {
      const timeslotPromise = axios.get(
        "https://little-munchkin-photography.herokuapp.com/api/Timeslots/available"
      );
      const complete = await Promise.resolve(timeslotPromise);
      updateTimeslots(complete);
    };

    const updateTimeslots = async (props) => {
      setTimeslots(props.data.response);
      setSelectedProduct(props.data.response[0]);
      setTimeslotsLoaded(true);
    };

    const getLockedSlots = async () => {
      const lockedTimeslotsPromise = axios.get(
        "https://little-munchkin-photography.herokuapp.com/api/Timeslots/locked"
      );

      const complete = await Promise.resolve(lockedTimeslotsPromise);
      checkForUnlocks(complete);
    };

    const unlockTimeslot = async (props) => {
      const unlockDetails = {
        id: props._id,
      };

      axios.post(
        "https://little-munchkin-photography.herokuapp.com/api/timeslots/unlock",
        unlockDetails
      );
    };

    const checkForUnlocks = async (props) => {
      if (props.data.response) {
        props.data.response.forEach((timeslot) => {
          let now = new Date().toString();
          if (Date.parse(now) > Date.parse(timeslot.lock_time)) {
            unlockTimeslot(timeslot);
          }
        });
        getTimeslots();
      }
    };

    getLockedSlots();

    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Header />
      {!bookingMade && (
        <Fragment>
          <WelcomeSection />
          <div className="form-image-divider">
            {windowSize < 770 && (
              <div>
                <img
                  alt="Christmas Theme"
                  src={require("./images/IMG_0029.jpg")}
                />
              </div>
            )}
            <div>
              <ShootSelectionContext.Provider
                value={[
                  setSelectedProduct,
                  timeslots,
                  setTimeslotChosen,
                  timeslotsLoaded,
                ]}
              >
                {!timeslotChosen && <ShootSelector />}
              </ShootSelectionContext.Provider>
              {!detailsEntered && timeslotChosen && (
                <CustomerDetailsContext.Provider
                  value={[
                    customerName,
                    setCustomerName,
                    customerEmail,
                    setCustomerEmail,
                    setBasketOpen,
                    setDetailsEntered,
                    selectedProduct,
                    numberOfChildren,
                    setNumberOfChildren,
                  ]}
                >
                  <EnterDetails />
                </CustomerDetailsContext.Provider>
              )}
            </div>
            {windowSize > 769 && (
              <div>
                <img
                  alt="Christmas Theme"
                  src={require("./images/IMG_0029.jpg")}
                />
                <img
                  alt="Christmas Theme"
                  src={require("./images/IMG_8345a.jpg")}
                />
                <img
                  alt="Christmas Theme"
                  src={require("./images/IMG_7051a.jpg")}
                />
              </div>
            )}
            {windowSize < 770 && (
              <div>
                <img
                  alt="Christmas Theme"
                  src={require("./images/IMG_8345a.jpg")}
                />
                <img
                  alt="Christmas Theme"
                  src={require("./images/IMG_7051a.jpg")}
                />
              </div>
            )}
          </div>
          <PaymentContext.Provider
            value={[
              selectedProduct,
              setPaymentError,
              basketOpen,
              customerName,
              customerEmail,
              setBookingMade,
              numberOfChildren,
            ]}
          >
            {basketOpen && <PaypalButtons />}
          </PaymentContext.Provider>
          <PaymentErrorContext.Provider value={[paymentError]}>
            {paymentError && <PaymentError />}
          </PaymentErrorContext.Provider>
        </Fragment>
      )}
      <BookingConfirmationContext.Provider value={[selectedProduct]}>
        {bookingMade && <BookingComplete />}
      </BookingConfirmationContext.Provider>
    </Fragment>
  );
}

export default App;
